/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions, FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped, FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSON, } from './FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions';
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGamesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateFromSocialFacebookInstantGamesOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromSocialRequestFacebookInstantGames.js.map